import { OptionI } from '@root/src/app/designSystem/contextMenu/contextMenu';
import { HandlersI } from './actions';
import getOptionButtons from './optionButtons';

export type ActionOptions = {
  optionsPending: Array<OptionI>;
  optionsConfirmedAntigen: Array<OptionI>;
  optionsConfirmedNotAntigen: Array<OptionI>;
  optionsDefaultOrOrdered: Array<OptionI>;
  optionsDone: Array<OptionI>;
  generateCertificateOptions: Array<OptionI>;
  optionsDoneResendCertificate: Array<OptionI>;
  optionsDoneDownloadCertificate: Array<OptionI>;
  optionsDoneWithDownloadAndResendCertificate: Array<OptionI>;
};

const getActionOptions = (handlers: HandlersI): ActionOptions => {
  const {
    confirmButtonOptions,
    markTestedButtonOptions,
    addResultButtonOptions,
    startTimerButtonOptions,
    resendCertificateButtonOptions,
    deleteOrderButtonOptions,
    generateCertificatePCR,
    generateCertificateAntigen,
    downloadCertificateButtonOptions,
  } = getOptionButtons(handlers);

  const optionsPending: Array<OptionI> = [
    {
      type: 'component',
      details: addResultButtonOptions,
    },
  ];

  const optionsConfirmedAntigen: Array<OptionI> = [
    {
      type: 'component',
      details: addResultButtonOptions,
    },
    {
      type: 'component',
      details: startTimerButtonOptions,
    },
  ];

  const optionsConfirmedNotAntigen: Array<OptionI> = [
    {
      type: 'component',
      details: markTestedButtonOptions,
    },
  ];

  const optionsDefaultOrOrdered: Array<OptionI> = [
    {
      type: 'component',
      details: confirmButtonOptions,
    },
  ];

  const optionsDone: Array<OptionI> = [
    {
      type: 'component',
      details: deleteOrderButtonOptions,
    },
  ];

  const optionsDoneWithDownloadAndResendCertificate: Array<OptionI> = [
    {
      type: 'component',
      details: resendCertificateButtonOptions,
    },
    {
      type: 'component',
      details: downloadCertificateButtonOptions,
    },
  ];

  const optionsDoneDownloadCertificate: Array<OptionI> = [
    {
      type: 'component',
      details: downloadCertificateButtonOptions,
    },
  ];

  const optionsDoneResendCertificate: Array<OptionI> = [
    {
      type: 'component',
      details: resendCertificateButtonOptions,
    },
  ];

  const generateCertificateOptions: Array<OptionI> = [
    {
      type: 'component',
      details: generateCertificatePCR,
    },
    {
      type: 'component',
      details: generateCertificateAntigen,
    },
    {
      type: 'component',
      details: generateCertificateAntigen,
    },
    {
      type: 'component',
      details: generateCertificateAntigen,
    },
    {
      type: 'component',
      details: generateCertificateAntigen,
    },
  ];

  return {
    optionsPending,
    optionsConfirmedAntigen,
    optionsConfirmedNotAntigen,
    optionsDefaultOrOrdered,
    optionsDone,
    generateCertificateOptions,
    optionsDoneResendCertificate,
    optionsDoneDownloadCertificate,
    optionsDoneWithDownloadAndResendCertificate,
  };
};

export default getActionOptions;
